<script lang="ts" module>
  // TODO: Not sure how to support this case in Svelte 5, but not sure we're using it, either.
  // import type { SvelteComponent } from 'svelte';
  // export type IconType = typeof SvelteComponent | string;
</script>

<script lang="ts">
  import { isPresent, isString } from '@yp/common/identity.ts';
  import type { DaisyRoleScheme } from '../styles.ts';
  import { SchemeToTextColor } from '../styles.ts';
  import { classes, styles } from './util.ts';

  interface Props {
    icon: string; // IconType;
    size?: string | number | undefined;
    filled?: boolean | undefined;
    ariaLabel?: string | undefined;
    class?: string | undefined;
    style?: string | undefined;
    scheme?: DaisyRoleScheme | undefined;
  }

  const {
    icon,
    size = 6,
    filled = false,
    ariaLabel,
    class: propClass,
    style: propStyle,
    scheme,
  }: Props = $props();

  const symbolStyle = $derived(
    styles(
      `font-size: ${isString(size) ? size : `${size * 4}px`}`,
      isString(size) ? undefined : `font-variation-settings: 'OPSZ' ${size * 4}`,
      filled ? `font-variation-settings: 'FILL' 1` : '',
    ),
  );
  const style = $derived(
    styles(
      isString(size)
        ? `width: ${size}; height: ${size}`
        : `width: ${size / 4}rem; height: ${size / 4}rem`,
      propStyle,
    ),
  );
  const clazz = $derived(
    classes(propClass, isPresent(scheme) ? SchemeToTextColor[scheme] : undefined),
  );

  // $effect(() => console.log('propClass', icon, $state.snapshot(propClass)));
  // $effect(() => console.log('clazz', icon, $state.snapshot(clazz)));

  function isSvg(s: string) {
    try {
      if (s.startsWith('/@fs/')) {
        s = `file://${s}`;
      }
      const url = new URL(s);
      return url.pathname.endsWith('.svg');
    } catch (_err) {
      return false;
    }
  }

  function isImage(s: string) {
    return s.endsWith('.png');
  }
</script>

<!-- {#if !isString(icon)}
  <icon class={clazz} {style} aria-hidden="true" />
{:else} -->
<div aria-label={ariaLabel} class="inline-block text-center leading-[0] {clazz}" {style}>
  {#if isSvg(icon)}
    <img src={icon} class="w-0 min-w-full" />
  {:else if isImage(icon)}
    <img src={icon} />
  {:else}
    <span class="material-symbols-outlined" style={symbolStyle}>{icon}</span>
  {/if}
</div>
<!-- {/if} -->
